import React from "react";
import { CssFormControlField, CssInputLabel, useStyles } from "../../../../styles/DoctorStyles/ui/form";

import { OutlinedInput, FormHelperText } from "@material-ui/core";

const EmailOutlinedInput = ({
  name,
  label,
  required,
  register,
  registerOptions,
  errors,
  ...remaining
}) => {
  const classes = useStyles();

  const registerOption =
    registerOptions && registerOptions[name]
      ? registerOptions[name]
      : undefined;

  let isError = false;
  let errorMessage = "";
  if (errors && errors.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errors[name].message;
  }

  const handleInvalidDefault = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <CssFormControlField
      size="small"
      className={classes.root}
      variant="outlined"
    >
      <CssInputLabel
        className={classes.root}
        htmlFor={`outlined-adornment-${name}`}
      >
        {label}
        {required ? <span style={{ color: "red" }}> *</span> : ""}
      </CssInputLabel>
      <OutlinedInput
        {...register(name, registerOption)}
        id={`outlined-adornment-${name}`}
        className={classes.margin}
        type={"email"}
        defaultValue=""
        error={isError}
        {...remaining}
        labelWidth={215}
        aria-describedby="email-helper-text"
        onInvalid={handleInvalidDefault}
      />
     <FormHelperText id={`${name}-helper-text`}>
        {errorMessage && (
          <div className="div-horizontal-form">
            <img src="/doctor/error-icon.svg" className="error-icon" alert="Error icon" alt="icon" />
            {errorMessage}
          </div>
        )}
      </FormHelperText>
    </CssFormControlField>
  );
};

export default EmailOutlinedInput;
